import { render, staticRenderFns } from "./ShippingHistoryTable.vue?vue&type=template&id=0a41b30c&scoped=true&"
import script from "./ShippingHistoryTable.vue?vue&type=script&lang=js&"
export * from "./ShippingHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./ShippingHistoryTable.vue?vue&type=style&index=0&id=0a41b30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a41b30c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
